/**
 * EL ÚNICO punto de conversión de moneda LOCAL → US$ de visualización de todo el ER v2
 * (Fase 3). Ver docs/decisiones/2026-10-04-reingenieria-ebitda-fase3-diseno.md §1.2/§1.3.
 *
 * No confundir con la conversión moneda EXTRANJERA → LOCAL de un documento (UF/USD de una
 * venta/factura a CLP/PEN) — esa sigue resolviéndose donde ya se resuelve hoy
 * (`getRateForOpp`/`convertirAMonedaLocal`, con la fecha real del documento) y no cambia: el
 * problema que la Fase 3 centraliza es específicamente el de local→US$ para mostrar en
 * pantalla (H10), no el de extranjera→local.
 *
 * Criterio 1 (decisión de Ignacio, 2026-10-04): un registro con fecha propia se convierte con
 * el TC de ESA fecha exacta. Un registro sin fecha propia (`fecha: null`) se convierte con el
 * TC PROMEDIO de los valores reales del mes al que pertenece (`ano`/`mesIndice`).
 *
 * En los pasos 3.1-3.7 este archivo todavía NO se cablea a ningún consumidor real con el
 * criterio de hoy ("último TC del mes") — eso se decide en 3.6/3.8. `convertirRegistroAUSD`
 * YA implementa el Criterio 1 desde el día uno (así no hay que reescribirlo en 3.8), pero
 * nadie lo llama todavía fuera de sus propios tests.
 */

import { getDolarValue, calcularDolarMensualPromedio } from "../../utils/exchangeRateService";

/**
 * Convierte un RegistroFinancieroER a US$. Devuelve un registro NUEVO con `montoUSD`
 * agregado (no muta el original).
 */
export const convertirRegistroAUSD = (registro) => {
  if (registro.fecha) {
    const tc = getDolarValue(registro.fecha, registro.pais);
    return { ...registro, montoUSD: tc ? registro.montoLocal / tc : 0 };
  }
  const tc = calcularDolarMensualPromedio(registro.pais, registro.ano)[registro.mesIndice];
  return { ...registro, montoUSD: tc ? registro.montoLocal / tc : 0 };
};

/** Azúcar sobre `convertirRegistroAUSD` para un array completo. */
export const convertirRegistrosAUSD = (registros) => (registros || []).map(convertirRegistroAUSD);
